/**
 * EngineLanguageNote -- round 12 I2, and it is a stated position rather
 * than a missing feature.
 *
 * The Marsad Engine composes its prose in English. There is no locale
 * anywhere in the prompt path, and no field in which a translation could
 * sit beside the English; the full measurement and the alternatives are
 * in `docs/engine-locale-scope.md`. Commissioning the whole interface
 * catalogue would not translate one word of what the Engine writes.
 *
 * So the product says so, where the prose lands, in the reader's own
 * language. The precedent is E6: "a stated decision that the scenes are
 * English-only, with a sentence on them saying so" was offered by the
 * fix list itself as an acceptable answer to this class of problem, and
 * it is the only one of the three options that creates no record anyone
 * has to live with -- asking the Engine in Arabic would seal prose from
 * a model nobody has measured in Arabic, and storing a translation
 * beside the sealed English would seal a rendering nobody has certified.
 *
 * IT RENDERS NOTHING IN ENGLISH, deliberately. To an English reader the
 * sentence is noise about a language they are already reading. It is
 * dormant today because English is the only catalogue on offer, and it
 * appears by itself the moment a real one lands -- the same posture the
 * language toggle takes.
 */
import { useTranslation } from "react-i18next";

export function EngineLanguageNote(): JSX.Element | null {
  const { t, i18n } = useTranslation();
  const lang = i18n.language || "en";
  // Any English variant: nothing to say. Everything else -- including the
  // dev pseudo-locale, so the Arabic pass sees it and can check it fits.
  if (lang === "en" || lang.startsWith("en-")) return null;
  return (
    <p data-testid="engine-language-note" className="mt-2 text-[11px] text-slate-500">
      {t("common.engine.answersInEnglish")}
    </p>
  );
}
